import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import Logo from './Logo';
import Steps from './Steps';
import CTA from './CTA';
import { Img } from 'app/ui_components/tags';
import USFoods from 'static/images/usfoods.png';

const El = styled(Flex)`
  background-color: white;
  min-height: 60px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 999;
  box-shadow: 0 4px 3px 0 #e2e2e21f;
  transition: ease 1s;

  @keyframes onLoad {
    from {
      opacity: 0;
      top: -100px;
    }
    to {
      opacity: 1;
      top: 0px;
    }
  }

  animation-name: onLoad;
  animation-duration: 1s;
  animation-delay: 0.5s;
  animation-fill-mode: both;
`;

// The Steps component need to be aware of the container's x-axis
// padding in order to acalculate a full view width top border (mobile-only)
const X_PADDING = '18px';

const Container = ({ showCTA, step, hideSteps, usFoods, numSteps }) => (
  <El px={X_PADDING} alignItems="center" id="topbar">
    {usFoods && <Img src={USFoods} padding={5} margins={[0, 2, 0, 0]} />}
    <Logo
      width={[1, 1, hideSteps ? 1 : 1 / 4]}
      text={usFoods ? 'Website Report' : 'The Restaurant Website Report'}
    />
    {!hideSteps && (
      <Steps step={step}
        numSteps={numSteps}
        parentXPadding={X_PADDING} width={[1, 1, 1 / 2]} />
    )}
    {showCTA && <CTA />}
  </El>
);

Container.propTypes = {
  showCTA: PropTypes.bool.isRequired,
  step: PropTypes.number.isRequired,
  hideSteps: PropTypes.bool.isRequired,
  usFoods: PropTypes.bool.isRequired,
  numSteps: PropTypes.number.isRequired
};

Container.defaultProps = {
  showCTA: false,
  hideSteps: true,
  usFoods: false,
  numSteps: 3
};

const mapStateToProps = ({
  usFoods,
  step,
  grade: { staff_request, sales_link }
}) => {
  const baseShowCTA = Boolean((step === 3 && !staff_request) || (staff_request && sales_link));

  return ({
    usFoods,
    showCTA: !usFoods && baseShowCTA,
    hideSteps: step === 0
  });
};

export default connect(
  mapStateToProps,
  null
)(Container);
